import {
  Box,
  Divider,
  IconButton,
  InputAdornment,
  Popover,
  TextField,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { getApiCall, postApiCall } from 'api/apiService';
import { GET_TEMPLATE_TEXT, POST_TEMPLATE_TEXT } from 'constant/app.config';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { poppins300, poppins400 } from 'theme/common.style';

const SearchIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.70865 1.5C4.72742 1.5 1.5 4.65614 1.5 8.54945C1.5 12.4427 4.72742 15.5989 8.70865 15.5989C10.4114 15.5989 11.9763 15.0216 13.2097 14.0561L15.5528 16.3415L15.6151 16.394C15.8327 16.5514 16.1411 16.5335 16.3379 16.3405C16.5544 16.1282 16.554 15.7845 16.3369 15.5727L14.0214 13.3142C15.1987 12.0595 15.9173 10.3866 15.9173 8.54945C15.9173 4.65614 12.6899 1.5 8.70865 1.5ZM8.70866 2.5858C12.0767 2.5858 14.807 5.25582 14.807 8.54945C14.807 11.8431 12.0767 14.5131 8.70866 14.5131C5.34064 14.5131 2.61033 11.8431 2.61033 8.54945C2.61033 5.25582 5.34064 2.5858 8.70866 2.5858Z"
        fill="#666666"
      />
    </svg>
  );
};

const EditIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.11642 13.1288L14.7142 1.53107C14.7331 1.5254 14.7536 1.5195 14.7757 1.51351C14.9346 1.47046 15.1639 1.42565 15.433 1.42193C15.9511 1.41479 16.6387 1.55583 17.314 2.23112C17.9893 2.90641 18.1303 3.59395 18.1232 4.11213C18.1195 4.38118 18.0746 4.61045 18.0316 4.76938C18.0256 4.79148 18.0197 4.81202 18.014 4.8309L6.41625 16.4287L2.66644 16.8787L3.11642 13.1288Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M11.8906 2.94336L16.3802 7.43293"
        stroke="white"
        stroke-width="2"
      />
    </svg>
  );
};

const DeleteIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 5.16699H18.5L17.9875 15.4167C17.8545 18.0777 15.6581 20.167 12.9938 20.167H9.00625C6.34188 20.167 4.14554 18.0777 4.01248 15.4167L3.5 5.16699Z"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M6.83594 5.16699V4.83366C6.83594 3.1768 8.17908 1.83366 9.83594 1.83366H12.1693C13.8261 1.83366 15.1693 3.1768 15.1693 4.83366V5.16699"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M1.83594 5.16699H20.1693"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13.5 10.167V14.3337"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M8.5 10.167V14.3337"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

const TemplateText = ({ anchorElMessage, setAnchorElMessage, setDetails }) => {
  const [searchTempText, setSearchTempText] = useState('');
  const [selectedText, setSelectedText] = useState(null);
  const [templateTexts, setTemplateTexts] = useState(null);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSearchText = () => {};
  const handleDeleteTemplate = (tempText) => {
    const inputData = {
      isActive: 0,
      templateId: tempText?.templateId,
      templateText: tempText?.templateText,
    };
    postApiCall(POST_TEMPLATE_TEXT, inputData).then((res) => {
      if (res?.data?.status == '1') {
        getTemplateText();
        Swal.fire({
          title: 'Success',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  const getTemplateText = () => {
    getApiCall(GET_TEMPLATE_TEXT).then((res) => {
      if (res?.data) {
        setTemplateTexts(res?.data?.templateDetails);
      }
    });
  };
  const handleEditTemplate = () => {
    if (searchTempText != '') {
      const inputData = {
        isActive: 1,
        templateId: selectedText?.templateId,
        templateText: searchTempText,
      };
      postApiCall(POST_TEMPLATE_TEXT, inputData).then((res) => {
        if (res?.data?.status == '1') {
          getTemplateText();
          setSearchTempText('');
          setSelectedText(null);
          Swal.fire({
            title: 'Success',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
        }
      });
    }
  };

  const handleEditTemplateClicked = (tempText) => {
    setSelectedText(tempText);
    setSearchTempText(tempText?.templateText);
  };
  const handleSaveTemplate = () => {
    if (searchTempText != '') {
      const inputData = {
        isActive: 1,
        templateText: searchTempText,
      };
      postApiCall(POST_TEMPLATE_TEXT, inputData).then((res) => {
        if (res?.data?.status == 1) {
          getTemplateText();
          setSearchTempText('');
          Swal.fire({
            title: 'Success',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
        }
      });
    }
  };

  useEffect(() => {
    getTemplateText();
  }, [anchorElMessage]);

  return (
    <Popover
      open={anchorElMessage}
      anchorEl={anchorElMessage}
      onClose={() => {
        setAnchorElMessage(false);
        setSelectedText(null);
        setSearchTempText('');
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        width: matchessm ? '100%' : 'auto',
      }}
    >
      <Box
        sx={{
          padding: '10px',
        }}
      >
        <TextField
          placeholder="Search"
          InputLabelProps={{
            shrink: false,
          }}
          sx={{
            '& .MuiInputLabel-root': {
              fontFamily: 'poppins',
              ...poppins300,
              marginLeft: '25px',
            },
            '& .MuiInputBase-input': {
              fontFamily: 'Poppins',
              ...poppins300,
            },
            width: '100%',
            borderRadius: '5px',
            height: '50px',
          }}
          margin="dense"
          type="text"
          value={searchTempText}
          onChange={(e) => {
            setSearchTempText(e.target.value);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          width: matchessm ? '100%' : '718px',
          height: '150px',
          overflowY: 'scroll !important',
          paddingLeft: '10px',
          paddingRight: '10px',
          fontFamily: 'poppins',
          scrollbarWidth: 'thin !important',
          '&::-webkit-scrollbar': {
            display: 'block !important',
            scrollbarWidth: 'thin !important',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888 !important',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#555 !important',
          },
        }}
      >
        {templateTexts ? (
          templateTexts?.map((item, index) => (
            <Box
              sx={{
                ...poppins400,
                cursor: 'pointer',
                padding: '5px 12px',
                color: '#666666',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                '&:hover': {
                  backgroundColor: '#007AFF',
                  color: 'white',
                },
              }}
            >
              <Box
                sx={{
                  width: '75%',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  '&:hover': {
                    backgroundColor: '#007AFF',
                    color: 'white',
                  },
                }}
                onClick={() => {
                  //   setSelectedText(item);
                  setDetails(item?.templateText);
                  setAnchorElMessage(false);
                }}
              >
                {item?.templateText}
              </Box>

              <Box
                sx={{
                  marginRight: '12px',
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '20px',
                  alignItems: 'center',
                }}
              >
                <IconButton
                  onClick={() => {
                    handleEditTemplateClicked(item);
                  }}
                >
                  <EditIcon />
                </IconButton>

                <IconButton
                  onClick={() => {
                    handleDeleteTemplate(item);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          ))
        ) : (
          <Box
            sx={{
              textAlign: 'center',
              padding: '30px',
            }}
          >
            No Template Found
          </Box>
        )}
      </Box>
      <Divider />
      {selectedText == null ? (
        <Box
          sx={{
            padding: ' 10px 30px 15px 15px',
            fontFamily: 'poppins',
            fontSize: '16px',
            fontWeight: '500',
            color: '#666666',
            cursor: 'pointer',
            '&:hover': {
              color: '#272727',
            },
          }}
          onClick={() => {
            handleSaveTemplate();
          }}
        >
          + Save current text as Template
        </Box>
      ) : (
        <Box
          sx={{
            padding: ' 10px 30px 15px 15px',
            fontFamily: 'poppins',
            fontSize: '16px',
            fontWeight: '500',
            color: '#666666',
            cursor: 'pointer',
            '&:hover': {
              color: '#272727',
            },
          }}
          onClick={() => {
            handleEditTemplate();
          }}
        >
          Update current Template
        </Box>
      )}
    </Popover>
  );
};

export default TemplateText;
